import { FC, Fragment, ReactNode } from 'react';
import { MutationFunction, MutationOptions, MutationResult } from '@apollo/client';
import { Mutation } from '@apollo/client/react/components';
import LoadingBar from './LoadingBar';

interface WrappedMutationProps extends MutationOptions {
  children: (mutateFn: MutationFunction, result: MutationResult) => any;
  loader?: ReactNode;
  onCompleted?: () => void;
  onError?: (err: any) => any;
  overrideStates?: boolean;
}

/**
 * @render react
 * @name WrappedMutation component
 * @description WrappedMutation component.
 * @example
 * <WrappedMutation />
 */

const WrappedMutation: FC<WrappedMutationProps> = ({ children, ...rest }) => (
  <Mutation {...rest}>
    {(mutateFn: MutationFunction, result: MutationResult) => (
      <Fragment>
        {!rest.overrideStates && result.loading && rest.loader}
        {children(mutateFn, result)}
      </Fragment>
    )}
  </Mutation>
);

WrappedMutation.defaultProps = {
  loader: <LoadingBar />,
  overrideStates: false,
};

export default WrappedMutation;
